<template>
  <div style="position: relative">
    <div @click="toPath" class="box-card" :style="{cursor:cardCursor}">
      <div class="box-svg">
        <img :src="svgBgImage" style="position: absolute;left:0px;top:0" width="80px" height="80px"/>
        <img :src="svgUrl" v-if="svgUrl" style="position: absolute;left: 20px;top: 20px" width="40px" height="40px">
        <slot></slot>
      </div>
      <div class="box-title" :style="{backgroundColor: titleBgColor,color: titleColor}">
        <div style="padding-left: 7px;text-align: left;font-size: 20px">
          <p>{{title}}</p>
        </div>
        <div style="padding-left: 7px;text-align: left;font-size: 13px">
          {{subtitle}}
        </div>
      </div>
    </div>
    <div v-if="messageDisabled" class="box-message" :style="{backgroundColor: messageBgColor}">
      <div :class="messageScroll? 'message': ''">
        {{messageDisabled}}
      </div>
    </div>
  </div>
</template>

<script>
import u47 from "@/assets/modularSvg/background black.jpg"
import u49 from "@/assets/modularSvg/background orange.jpg"
export default {
  name: "modular",
  computed: {
    cardCursor(){
      if (this.disabled)
        return 'not-allowed'
      return 'pointer'
    },
    svgBgImage(){
      if (this.disabled)
        return u47
      return u49
    },
    titleBgColor(){
      if (this.disabled)
        return '#bebebe'
      return '#FFFFFF'
    },
    titleColor(){
      if (this.disabled)
        return '#FFFFFF'
      return ''
    },
    messageBgColor(){
      if (this.disabled)
        return '#bebebe'
      return this.messageColor
    },
    messageScroll(){
      return this.messageDisabled ? this.messageDisabled.length > 15 : false
    },
    messageDisabled(){
      if (this.disabled)
        return '需开通可联系平台方'
      return this.message
    }
  },
  props: {
    title: {
      type: String,
      default: undefined
    },
    subtitle: {
      type: String,
      default: undefined
    },
    message: {
      type: String,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: true
    },
    svgUrl: {
      type: String,
      default: undefined
    },
    path: {
      type: String,
      default: undefined
    },
    messageColor: {
      type: String,
      default: 'rgb(245,128,32)'
    }
  },
  methods: {
    toPath(){
      if (!this.disabled && this.path){
        this.$router.replace({ path: this.path })
      }
      if (!this.disabled && !this.path){
        this.$emit('toPath')
      }
    }
  }
}
</script>

<style scoped>
.box-card {
  width: 240px;
  height: 80px;
  border: unset;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 20%)
}

.box-svg {
  width: 80px;
  height: 80px;
  float: left;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  overflow: hidden;
  position: relative;
}

.box-title {
  width: 160px;
  height: 80px;
  float: left;
  border-bottom-right-radius: 8px;
  border-top-right-radius: 8px;
  overflow: hidden;
  background-color: #FFFFFF;
}

.box-card /deep/ .el-card__body {
  padding: unset;
}

.box-message {
  width: 220px;
  height: 20px;
  color: #FFFFFF;
  font-size: 13px;
  line-height: 20px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 20%);
  overflow:hidden;
  white-space:nowrap;
  position:absolute;
  left: 10px;
}

.message {
  position: absolute;
  white-space:nowrap;
  animation: scroll 10s infinite linear normal;
}

@keyframes scroll {
  from {
    transform: translateX(200px)
  }
  to {
    transform: translateX(-300px)
  }
}
</style>
